<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

            <div class="col-12">
                <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Laporan Saldo Awal</h5>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="createLapSaldoAwal()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Tahun : </label>
                            <input v-model.number="tahun" type="number" min="2022" />
                            <has-error :form="form" field="tanggal"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <!--button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button-->
                        <button type="submit" class="btn btn-success fas fa-file-excel"> Ekspor</button>
                        <button type="button" @click="createLapSaldoAwalAll" class="btn btn-secondary fas fa-file-excel" v-if="$gate.isAdmin1()"> Per Unit Kerja</button>
                    </div>
                  </form>
                </div>
            </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        data () {
            return {
                defaultDate: '2022-01-01',
                DatePickerFormat: 'yyyy',
                editmode: false,
                adjustments : {},
                tahun: '',
                form: new Form({
                    id : ''                    
                })
            }
        },
        methods: {            
            createLapSaldoAwal(){
                //let routeData = this.$router.resolve({ path: "/lapsaldoawalxls" , query: {tahun: this.tahun, unit_kerja:'opd'}});
                //window.open(routeData.href, '_blank');
				
				axios.get('api/lapsaldoawalxls?tahun=' + this.tahun + '&unit_kerja=opd',
                        {responseType: 'blob'})
                    .then(response => {
                            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute('download', 'saldoawal-'+this.tahun+'.xlsx');
                            document.body.appendChild(fileLink);
                            fileLink.click();
                        })
            },
            createLapSaldoAwalAll(){
                //let routeData = this.$router.resolve({ path: "/lapsaldoawalxls" , query: {tahun: this.tahun, unit_kerja:'uk'}});
                //window.open(routeData.href, '_blank');
				
				axios.get('api/lapsaldoawalxls?tahun=' + this.tahun + '&unit_kerja=uk',
                        {responseType: 'blob'})
                    .then(response => {
                            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute('download', 'saldoawalall-'+this.tahun+'.xlsx');
                            document.body.appendChild(fileLink);
                            fileLink.click();
                        })
            },
            setYear(date) {                
                alert(date);
                let d=new Date(date);
                this.tahun=d.getFullYear;
                alert(this.tahun);
            }
        },
        mounted() {
            //let d=new Date();
            //this.tahun=d.getFullYear;
            this.tahun= new Date().getFullYear() ;
            console.log('Component mounted.')
        },
        created() {
            
        },
        components: {
            Datepicker
        }
    }
</script>